var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_footer_social_instagram") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_footer_social_instagram"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-14-Copy",
    transform: "translate(6.000000, 6.000000)",
    fill: "#FA7D05"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0981371,0 L1.90186291,0 C0.851430598,0 0,0.849248561 0,1.89749884 L0,14.1025012 C0,15.150315 0.851430598,16 1.90186291,16 L14.0981371,16 C15.1485694,16 16,15.150315 16,14.1025012 L16,1.89749884 C16,0.849248561 15.1485694,0 14.0981371,0 L14.0981371,0 Z M11.5002046,2.49974088 C11.5002046,2.22393148 11.7240815,2.00005455 11.9998909,2.00005455 L13.4998227,2.00005455 C13.7760685,2.00005455 13.9999454,2.22393148 13.9999454,2.49974088 L13.9999454,4.0001091 C13.9999454,4.2759185 13.7760685,4.49979543 13.4998227,4.49979543 L11.9998909,4.49979543 C11.7240815,4.49979543 11.5002046,4.2759185 11.5002046,4.0001091 L11.5002046,2.49974088 L11.5002046,2.49974088 Z M8.01854731,4.94885852 C9.71791725,4.94885852 11.095655,6.32354145 11.095655,8.01854731 C11.095655,9.71398958 9.71791725,11.0882361 8.01854731,11.0882361 C6.31961378,11.0882361 4.94187601,9.71398958 4.94187601,8.01854731 C4.94187601,6.32354145 6.31961378,4.94885852 8.01854731,4.94885852 L8.01854731,4.94885852 Z M14.5000682,13.9999454 C14.5000682,14.2757548 14.2761913,14.5000682 13.9999454,14.5000682 L2.00005455,14.5000682 C1.72380874,14.5000682 1.49993181,14.2757548 1.49993181,13.9999454 L1.49993181,6.49984998 L3.49998636,6.49984998 C3.23945122,6.87472384 3.15129695,7.5742847 3.15129695,8.01854731 C3.15129695,10.695906 5.33507896,12.8744511 8.01854731,12.8744511 C10.7024521,12.8744511 12.8862341,10.695906 12.8862341,8.01854731 C12.8862341,7.5742847 12.822955,6.88563402 12.5000136,6.49984998 L14.5000682,6.49984998 L14.5000682,13.9999454 L14.5000682,13.9999454 Z",
    id: "Instagram"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInstagram);
export default __webpack_public_path__ + "static/media/ic_instagram.9c21dbb34371656f80d0c6f8f32dd539.svg";
export { ForwardRef as ReactComponent };